import { __assign, __rest } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function LayerPath(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Svg, __assign({ display: "block", height: "24px", viewBox: "0 0 24 24", width: "24px" }, props),
        React.createElement("path", { d: "M5,15.47q6.39-16,6.59-7c.2,8.91,4.65,13.5,7.76,3.14", fill: "none", stroke: "#000", strokeWidth: "1" }),
        React.createElement("circle", { cx: "5", cy: "17", opacity: "0.22", r: "1.5" }),
        React.createElement("path", { d: "M5,16a1,1,0,1,1-1,1,1,1,0,0,1,1-1m0-1a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z" }),
        React.createElement("circle", { cx: "20", cy: "10", opacity: "0.22", r: "1.5" }),
        React.createElement("path", { d: "M20,9a1,1,0,1,1-1,1,1,1,0,0,1,1-1m0-1a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z" })));
}
